import createDialog2 from "./createDialog";
import Dialog from "./dialog.vue";
const dialog2 = createDialog2(Dialog);
dialog2.create = createDialog2;
export default dialog2;
